import { ContentFlexComponent } from "components/flexComponents/Content/typings";
import CardWithLinkEditorial from "components/flexComponents/Content/factory/impl/editorials/CardWithLinkEditorial";

export class Affinity extends CardWithLinkEditorial {
  /* istanbul ignore next */
  constructor(editorial: ContentFlexComponent) {
    super(editorial);
  }

  public getEditorialItemClassName = (): string => "affinityCard all-y-gutter-three";
}

export default Affinity;
